import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export function NotificationHeader({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      width={40}
      justifyContent="flex-start"
      alignItems="center"
      height="100%"
    >
      {children}
    </Box>
  );
}
